import { dispatchSWUpdateEvent } from "./sw-build-update";

let _swRegistration = null;
const saveRegistration = r => {
  _swRegistration = r;
};

export const getRegistration = () => {
  return _swRegistration;
};

export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      // Register the service worker from the root path
      navigator.serviceWorker.register("/v2/sw.js")
        .then(registration => {
          saveRegistration(registration);
          console.log("Service Worker registered with scope:", registration.scope);

          // Check for updates
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
                console.log("New service worker available - skip waiting...");
                registration.waiting.postMessage({ type: "SKIP_WAITING" })
              }
            };
          };
        })
        .catch(error => {
          console.error("Service Worker registration failed:", error);
        });
    });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      dispatchSWUpdateEvent();
    });
  }
}

